import { Component, Inject } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
    selector: 'app-generic-error',
    templateUrl: './generic-error.component.html',
    styleUrls: ['./generic-error.component.scss'],
    standalone: false
})
export class GenericErrorComponent {

  constructor(public matdialogRef: MatDialogRef<GenericErrorComponent>) {}
}
